import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, DatePicker, Select, message } from "antd";
import moment from "moment";
import MedicalHistoryService from "../../../../Services/MedicalHistoryService";

function AddVaccination(props) {
  const [vaccineValue, setVaccineValue] = useState();
  const [vaccineDesc, setVaccineDesc] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [givenDate, setGivenDate] = useState();
  const formRef = useRef();

  const handleCancel = () => {
    props.onClose();
  };

  const handleDate = (date, dateString) => {
    if (dateString) {
      const constructedTime = dateString + " " + "00:00:00";
      setGivenDate(constructedTime);
    }
    else {
      setGivenDate('')
    }
  }

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handlehealthChange = (value, desc) => {
    setVaccineValue(value);
    setVaccineDesc(desc.description);
  };
  const vaccines = [
    { description: "Influenza(Flu)", code: "Influenza(Flu)" },
    { description: "Tetanus, Diphtheria, Pertussis (Td, Tdap)", code: "Tetanus, Diphtheria, Pertussis(Td,Tdap)" },
    { description: "Zoster (Shingles)", code: "Zoster(Shingles)" },
    { description: "Pneumococcal (PCV13, PPSV23)", code: "Pneumococcal(PCV13,PPSV23)" },
    { description: "Varicella (Chickenpox)", code: "Varicella(Chickenpox)" },
    { description: "Human Papillomavirus (HPV)", code: "Human Papillomavirus(HPV)" },
    { description: "Measles, Mumps, Rubella (MMR)", code: "Measles, Mumps, Rubella (MMR)" },
    { description: "Meningococcal", code: "Meningococcal" },
    { description: "Hepatitis A", code: "Hepatitis A" },
    { description: "Hepatitis B", code: "Hepatitis B" },
    { description: "Haemophilus influenzae type b (Hib)", code: "Haemophilus influenzae type b (Hib)" },
  ];

  const onFinish = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userObj = sessionStorage.getItem('login_result')
    const userData = userObj ? JSON.parse(userObj) : null;

    const currDate = new Date().toISOString();
    const date = currDate.split('T')[0];
    const time = currDate.split('T')[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const { pastInfo } = formRef.current.getFieldValue();
    if (!pastInfo || !givenDate) {
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }
    let payload = {
      account_Id: props.selectedPatient?.account_Id,
      clinic_Id: props.selectedPatient?.clinic_Id,
      userId: props.selectedPatient?.userId,
      createdDate: constructedTime,
      createdName: userData?.user?.firstName,
      givenDate: givenDate,
      createdBy: userData?.user?.userId,
      modifiedBy: userData?.user?.userId,
      status: 1,
      patientId: props.selectedPatient?.patientId,
      description: vaccineDesc,
      modifiedDate: constructedTime,
    };
    try {
      const response = await MedicalHistoryService.AddImmunisationHistory(payload);
      if (response.data === 1) {
        let payload = {
          patientId: props.selectedPatient?.patientId,
          account_Id: props.selectedPatient?.account_Id,
          clinic_Id: props.selectedPatient?.clinic_Id,
          userId: (props.permissionData === null || props.permissionData?.medicalHistory === 'N') ? props.selectedPatient?.userId : '',
          status: 1
        };
        try {
          const vaccineResponse = await MedicalHistoryService.PatientImmunisation(payload);
          props.handleLatestUpdate(vaccineResponse.data);
        }
        catch (e) {
          console.log(e);
        }
      }
      setIsLoading(false);
      formRef.current.resetFields();
      props.onClose();
    }
    catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  return (
    <div>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        disabled={isLoading}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Immunisation{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="pastInfo"
            >
              <Select
                style={{ width: "100%" }}
                onChange={handlehealthChange}
                placeholder="Select"
                value={vaccineValue}
                options={vaccines.map((ele) => ({
                  value: ele.code,
                  description: ele.description,
                  label: ele.description,
                  key: ele.code,
                }))}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item label={<span>Date<span style={{ color: "#FF000F" }}>*</span></span>} name="givenDate">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>

        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="border-brand-primaryColor bg-white border rounded-md text-brand-primaryColor text-sm px-6 py-1.5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button disabled={isLoading} onClick={onFinish} className="custom_filter rounded-md px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50">
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}

export default AddVaccination;
